import { Component,Inject } from '@angular/core';
import { NavItemService } from './nav-item.service';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { GEA_MES_NAVBAR_MENU_SERVICE, NavItem, GeaMesNavbarModule } from '@gea-mes/navbar';
import { BehaviorSubject,Subscription } from 'rxjs';
import {​​​​ GeaMesCognitoAuthService }​​​​ from '@gea-mes/cognito';
import { filter } from 'rxjs/operators';
import { appinfo } from './appinfo';
import { LoadingService } from './services/loading.service';
import { ShowNavBarService } from './services/show-nav-bar.service';
import { NgIf } from '@angular/common';
import { SpinnerComponent } from './loadingSpinner/spinner.component';

declare var gtag_setValue;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NgIf, GeaMesNavbarModule, SpinnerComponent, RouterOutlet]
})
export class AppComponent {

  Version: any;
  title = 'eola-app';
  productionMode: boolean;
  trackingid:string;
  userTitle:string;
  userDivision:string;
  logon$: Subscription;

  showNavBar: boolean = true;
  
  constructor (
    private router: Router,
    private geaMesCognito: GeaMesCognitoAuthService,
    public navService:NavItemService,
    private loadingService: LoadingService,
    private showNavBarService: ShowNavBarService,
    @Inject(GEA_MES_NAVBAR_MENU_SERVICE) private NavItem: BehaviorSubject<NavItem[]> 
   )
   {
    NavItem.next(navService.navItems);
    const navEndEvent$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    this.title = 'EOLA'
    this.Version = appinfo.version;
    
    console.log("Version: ", this.Version)
    this.router.events.subscribe(() => {
      this.loadingService.hide();
    });
   }
    ngOnInit(): void {
      gtag_setValue({"appversion": appinfo.version});
      this.showNavBarService.getShowNavBar().subscribe(out=>{
        this.showNavBar = out;
      });

    this.logon$ = this.geaMesCognito.sessionEstablished$.subscribe( out => {
      this.trackingid = this.geaMesCognito.getUserAttribute("trackingid");
      this.userTitle = this.geaMesCognito.getUserAttribute("title");
      this.userDivision = this.geaMesCognito.getUserAttribute("division");
      if (this.trackingid != undefined) {
        gtag_setValue({"sub": this.trackingid});
        gtag_setValue({"title": this.userTitle});
        gtag_setValue({"division": this.userDivision});
        if (this.logon$) this.logon$.unsubscribe(); // We've done the work we need to, can unsubscribe
      }       
    });

  }
}